import React from 'react';
import ReportingDonationThankYouPage from '../components/ReportingDonationThankYouPage';

const ReportingDonationThankYouApp = (props) => <ReportingDonationThankYouPage {...props} />;

export default ReportingDonationThankYouApp;
